module.exports = __webpack_public_path__ + "static/IMG_2248-8aaca0b2173aa6b07aebfa6f59ea5057.jpg";